export default __webpack_public_path__ + "static/media/link.e7879d81.svg";